import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';
import { Unit } from './types';

type GetUnits = { units: Unit[]; count: number; offset: number; total: number; success: boolean };

export const getUnits = async (): Promise<AxiosResponse<GetUnits>> => AxiosInstance.get('livechat/units');
